var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alert-list',{attrs:{"default":""}}),_vm._v(" "),_c('background',_vm._b({attrs:{"page":""}},'background',_vm.background,false),[_c('content-container',{attrs:{"children":_vm.content,"fluid":""}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9faa7d6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ContentPage.vue
// module id = 1262
// module chunks = 9